package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.dom.svg.Image
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun MarqueeRow() {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .bottom(0.px)
            .position(Position.Absolute)
            .borderTop(width = 2.px, color = Colors.Black, style = LineStyle.Solid)
            .borderBottom(width = 2.px, color = Colors.Black, style = LineStyle.Solid)
            .overflow(Overflow.Hidden),
        verticalAlignment = Alignment.CenterVertically
    ) {
        repeat(6) {
            Div(attrs = {
                style {
                    property("display", "flex")
                    property("align-items", "center")
                    property("white-space", "nowrap")
                    property("animation", "marquee 10s linear infinite")
                    property("min-width", "100%")
                }
            }) {
                ->
                Image(
                    modifier = Modifier.width(100.percent).objectFit(ObjectFit.Fill),
                    src = Res.Image.tira,
                )
            }
        }
    }
}